<template>
  <div class="clientone">
    <p class="ma-10">Client one will be added later.</p>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "clientone",
  components: {}
};
</script>
